import React, { useMemo, useState } from 'react';
import { TrashCanOutlined } from '@duxton-web/icons';
import { Modal, ModalProps, Tag, Tooltip, Typography } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import { isViewMode } from '../../constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '../../contexts/experiment-context';
import { deleteExperimentVariable } from '../../store/actions/experiment/action-creators';

const DeleteVariableModal = ({
  variableName,
  open,
  onCancel,
  onOk,
}: ModalProps & { variableName: string }) => {
  if (!open) return null;

  return (
    <Modal
      centered
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      title="Delete Variable"
      width={700}
      maskClosable={false}
      okText="Delete Variable"
      okButtonProps={{
        size: 'small',
        danger: true,
      }}
      cancelButtonProps={{
        size: 'small',
      }}
    >
      <Typography.Text>
        Are you sure you want to delete variable {variableName}?
      </Typography.Text>
    </Modal>
  );
};

const DeleteVariable = ({ variableName }: { variableName: string }) => {
  const params = useParams<{ action: string }>();
  const action = params.action;
  const disabled = isViewMode(action);

  const experimentDispatch = useExperimentDispatchContext();
  const experimentContext = useExperimentContext();
  const { variables } = experimentContext;

  const [open, setOpen] = useState(false);

  const variableType = useMemo(() => {
    return variables.find((v) => v.name === variableName)?.type;
  }, [variableName, variables]);

  return (
    <>
      <Tag style={{ width: '100%', height: 40 }} bordered={false}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            {variableName}&nbsp;
            <Typography.Metadata type="secondary">
              ({variableType})
            </Typography.Metadata>
          </div>
          {!disabled && (
            <Tooltip title={`Click here to delete ${variableName}`}>
              <TrashCanOutlined
                onClick={() => {
                  setOpen(true);
                }}
              />
            </Tooltip>
          )}
        </div>
      </Tag>
      <DeleteVariableModal
        variableName={variableName}
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        onOk={() => {
          setOpen(false);
          experimentDispatch(deleteExperimentVariable(variableName));
        }}
      />
    </>
  );
};

export default DeleteVariable;
